/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Suggest_IntroInputs */

const en_us2_community_suggest_intro = /** @type {(inputs: Community_Suggest_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell us what would make the app better for you. The team reads every suggestion, but cannot answer each one.`)
};

const pt_br2_community_suggest_intro = /** @type {(inputs: Community_Suggest_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conte o que deixaria o app melhor para você. A equipe lê cada sugestão, mas não consegue responder uma a uma.`)
};

const es_419_community_suggest_intro = /** @type {(inputs: Community_Suggest_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuéntanos qué haría la app mejor para ti. El equipo lee cada sugerencia, pero no puede responder una por una.`)
};

const pt_pt2_community_suggest_intro = /** @type {(inputs: Community_Suggest_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diz-nos o que tornaria a app melhor para ti. A equipa lê cada sugestão, mas não consegue responder a todas.`)
};

const fr_fr2_community_suggest_intro = /** @type {(inputs: Community_Suggest_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dis-nous ce qui rendrait l'appli meilleure pour toi. L'équipe lit chaque suggestion, mais ne peut pas répondre à chacune.`)
};

const de_de2_community_suggest_intro = /** @type {(inputs: Community_Suggest_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sag uns, was die App für dich besser machen würde. Das Team liest jeden Vorschlag, kann aber nicht auf jeden einzeln antworten.`)
};

const it_it2_community_suggest_intro = /** @type {(inputs: Community_Suggest_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dicci cosa renderebbe l'app migliore per te. Il team legge ogni suggerimento, ma non può rispondere a tutti.`)
};

/**
* | output |
* | --- |
* | "Tell us what would make the app better for you. The team reads every suggestion, but cannot answer each one." |
*
* @param {Community_Suggest_IntroInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_suggest_intro = /** @type {((inputs?: Community_Suggest_IntroInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Suggest_IntroInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_suggest_intro(inputs)
	if (locale === "es-419") return es_419_community_suggest_intro(inputs)
	if (locale === "pt-PT") return pt_pt2_community_suggest_intro(inputs)
	if (locale === "fr-FR") return fr_fr2_community_suggest_intro(inputs)
	if (locale === "de-DE") return de_de2_community_suggest_intro(inputs)
	if (locale === "it-IT") return it_it2_community_suggest_intro(inputs)
	return en_us2_community_suggest_intro(inputs)
});
export { community_suggest_intro as "community.suggest_intro" }